<vc-dialog
    [loading]="loading"
    [(visible)]="visible"
    [title]="title"
    [width]="width"
    [height]="height"
    [secondaryLabel]="closeLabel"
    [showPrimary]="false"
    [showSecondary]="true"
    [closeOnSecondary]="true"
    [showCloseIcon]="true"
    [actionsOnLeft]="false">
    <div class="vc-flex-column vc-pdf-viewer-dialog-content">
        <vc-pdf-viewer
            [src]="src"
            [filenameForDownload]="title"
            (pageChange)="pageChange.emit($event)"
            (pdfLoaded)="pdfLoaded.emit($event)"
            (pdfLoadingFailed)="pdfLoadingFailed.emit($event)"
            (passwordPromptCancelled)="close()"></vc-pdf-viewer>
    </div>
</vc-dialog>
